import { createBrowserRouter } from 'react-router-dom';
import Layout from '../components/Layout';
import ProfilePage from '../components/ProfilePage';
import ContentRecorder from '../components/ContentRecorder';
import ImageUploader from '../components/ImageUploader';
import QuestionsPage from '../components/QuestionsPage';
import LandingPage from '../components/LandingPage';
import HistoryPage from '../components/HistoryPage';
import BillingPage from '../components/BillingPage';
import AuthCallback from '../components/AuthCallback';
import ProtectedRoute from '../components/ProtectedRoute';
import ErrorBoundary from '../components/ErrorBoundary';
import PrivacyPolicy from '../components/PrivacyPolicy';

const routes = [
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: 'privacy',
        element: <PrivacyPolicy />,
      },
      {
        path: 'upload',
        element: <ProtectedRoute><ImageUploader /></ProtectedRoute>,
      },
      {
        path: 'questions',
        element: <ProtectedRoute><QuestionsPage /></ProtectedRoute>,
      },
      {
        path: 'recording',
        element: <ProtectedRoute><ContentRecorder /></ProtectedRoute>,
      },
      {
        path: 'profile',
        element: <ProtectedRoute><ProfilePage /></ProtectedRoute>,
      },
      {
        path: 'history',
        element: <ProtectedRoute><HistoryPage /></ProtectedRoute>,
      },
      {
        path: 'billing',
        element: <ProtectedRoute><BillingPage /></ProtectedRoute>,
      },
    ],
  },
  {
    path: '/auth/callback',
    element: <AuthCallback />,
    errorElement: <ErrorBoundary />,
  },
];

export const router = createBrowserRouter(routes);
